import type { Archetype } from "../lib/types";
import { useDrawOn } from "../lib/useMotion";

// 6유형 라인 일러스트 (디자인 핸드오프 bwek-types.jsx). ink(흰색) + accent(팝 컬러) 스트로크.
interface Props {
  typeId: Archetype;
  size?: number;
  ink?: string;
  accent?: string;
  sw?: number;
  draw?: boolean;
}

export default function TypeArt({ typeId, size = 88, ink = "#fff", accent = "#fff", sw = 3, draw = false }: Props) {
  const ref = useDrawOn<SVGSVGElement>(draw, 1700);
  const cm = { fill: "none", strokeLinecap: "round" as const, strokeLinejoin: "round" as const };
  let content = null;

  if (typeId === "cooler")
    content = (
      <g>
        <g stroke={ink} strokeWidth={sw} {...cm}>
          <path d="M50 80 C30 69 39 45 50 29 C61 45 70 69 50 80 Z" />
          <path d="M50 73 C42 65 45 52 50 44" strokeWidth={sw - 1} />
        </g>
        <g stroke={accent} strokeWidth={sw - 0.4} {...cm}>
          <line x1="75" y1="32" x2="75" y2="50" />
          <line x1="67" y1="37" x2="83" y2="45" />
          <line x1="83" y1="37" x2="67" y2="45" />
          <line x1="25" y1="54" x2="25" y2="70" />
          <line x1="18" y1="58" x2="32" y2="66" />
          <line x1="32" y1="58" x2="18" y2="66" />
        </g>
      </g>
    );
  else if (typeId === "firewall")
    content = (
      <g>
        <g stroke={accent} strokeWidth={sw} {...cm}>
          <path d="M35 50 C29 42 37 38 33 30 C42 38 40 46 35 50 Z" />
          <path d="M52 48 C45 39 54 34 49 25 C59 34 59 44 52 48 Z" />
          <path d="M68 50 C62 43 69 39 66 32 C74 40 73 47 68 50 Z" />
        </g>
        <g stroke={ink} strokeWidth={sw} {...cm}>
          <path d="M22 50 H78" />
          <path d="M22 63 H78" />
          <path d="M22 76 H78" />
          <path d="M22 50 V82 H78 V50" />
          <line x1="40" y1="50" x2="40" y2="63" />
          <line x1="60" y1="50" x2="60" y2="63" />
          <line x1="31" y1="63" x2="31" y2="76" />
          <line x1="50" y1="63" x2="50" y2="76" />
          <line x1="69" y1="63" x2="69" y2="76" />
          <line x1="40" y1="76" x2="40" y2="82" />
          <line x1="60" y1="76" x2="60" y2="82" />
        </g>
      </g>
    );
  else if (typeId === "cleancut")
    content = (
      <g>
        <path
          d="M57 16 L35 55 L48 55 L41 86 L71 41 L56 41 L63 16 Z"
          stroke={accent}
          strokeWidth={sw + 0.6}
          {...cm}
        />
      </g>
    );
  else if (typeId === "slowburn")
    content = (
      <g>
        <g stroke={ink} strokeWidth={sw} {...cm}>
          <path d="M14 84 L40 46 L46 40" />
          <path d="M54 40 L60 46 L86 84" />
          <path d="M14 84 H86" />
        </g>
        <g stroke={accent} strokeWidth={sw} {...cm}>
          <path d="M46 40 C47 53 44 61 48 72" />
          <path d="M55 41 C55 51 57 57 56 64" />
          <line x1="50" y1="37" x2="43" y2="24" />
          <line x1="50" y1="35" x2="50" y2="20" />
          <line x1="50" y1="37" x2="58" y2="25" />
        </g>
      </g>
    );
  else if (typeId === "deadcalm")
    content = (
      <g>
        <g stroke={ink} strokeWidth={sw} {...cm}>
          <path d="M42 52 H58 V82 H42 Z" />
          <path d="M50 52 V47" />
          <path d="M26 88 H74" />
        </g>
        <path d="M50 46 C45 41 47 34 50 29 C53 34 55 41 50 46 Z" stroke={accent} strokeWidth={sw} {...cm} />
      </g>
    );
  else if (typeId === "afterburn")
    content = (
      <g>
        <path d="M46 84 C35 75 41 62 46 53 C51 62 57 75 46 84 Z" stroke={accent} strokeWidth={sw} {...cm} />
        <g stroke={ink} strokeWidth={sw - 0.4} {...cm}>
          <path d="M46 53 C54 47 39 42 46 36 C53 30 39 25 47 18" />
          <path d="M47 18 C49 15 54 16 55 12" />
          <circle cx="39" cy="14" r="2.4" />
          <circle cx="58" cy="20" r="2" />
        </g>
      </g>
    );

  return (
    <svg ref={ref} width={size} height={size} viewBox="0 0 100 100" style={{ display: "block", overflow: "visible" }}>
      {content}
    </svg>
  );
}
